const About = () => {
  return (
    <div>
      <h1>About Page Cominig Up soon!!</h1>
    </div>
  );
}

export default About;